import styles from '@styles/components/General/CircularCheckbox.module.css';
import { useEffect, useState } from 'react';

const CircularCheckbox = ({value = undefined, initValue = false, onChange}) => {
  const [checked, setChecked] = useState(initValue);

  useEffect(() => {
    if (value !== undefined) {
      setChecked(value)
    }
  }, [value])

  const handleCheckboxChange = () => {
    if (value === undefined) {
      setChecked(!checked);
      onChange(!checked)
    } else {
      onChange(!value)
    }
  };

  return (
    <div className={styles.checkboxContainer} onClick={handleCheckboxChange}>
      <div className={`${styles.checkbox} ${checked ? styles.checked : ''}`}>
        {checked && <div className={styles.innerCircle}></div>}
      </div>
    </div>
  );
};

export default CircularCheckbox